import { render } from "./KioskFlowOrchestrator.vue?vue&type=template&id=dc8561c8&scoped=true"
import script from "./KioskFlowOrchestrator.vue?vue&type=script&lang=js"
export * from "./KioskFlowOrchestrator.vue?vue&type=script&lang=js"

import "./KioskFlowOrchestrator.vue?vue&type=style&index=0&id=dc8561c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc8561c8"]])

export default __exports__